export default __webpack_public_path__ + "static/commmune-online-customer-bcc453ca99b86357b5786a5c673d86df.jpg";